export const specials = [
  {
    id: "s1",
    title: "国产科幻的工业跃迁",
    cover: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20scene%20with%20deep%20red%20nebula%20and%20dramatic%20lighting%2C%20futuristic%20editorial%20poster%20style%2C%20bold%20abstract%20composition%2C%20no%20text&width=1200&height=680&seq=special-sci-fi-01&orientation=landscape",
    intro: "从视效工业到叙事表达，国产科幻正在完成一次扎实的集体跃迁。本专题集合近期最具代表性的科幻作品与深度观察。",
    editorNote: "不吹不黑，国产科幻最好的时候可能才刚刚开始。真正值得关注的，是那些愿意把一件小事做到极致的团队。",
    tags: ["科幻", "国产电影", "工业"],
    items: [
      { kind: "news", id: "n1" },
      { kind: "video", id: "v1" },
      { kind: "news", id: "n10" },
      { kind: "video", id: "v7" },
    ],
  },
  {
    id: "s2",
    title: "综艺的治愈经济学",
    cover: "https://readdy.ai/api/search-image?query=warm%20cozy%20night%20city%20lights%20with%20soft%20orange%20tones%2C%20emotional%20variety%20show%20poster%20style%2C%20atmospheric%20bokeh%2C%20no%20text&width=1200&height=680&seq=special-healing-02&orientation=landscape",
    intro: "当生活越来越快，慢下来的综艺反而成了刚需。本专题聚焦近期口碑最好的治愈系综艺节目。",
    editorNote: "观众要的从来不是煽情，而是在别人的故事里，短暂地喘一口气。",
    tags: ["综艺", "治愈", "纪实"],
    items: [
      { kind: "news", id: "n2" },
      { kind: "video", id: "v2" },
      { kind: "news", id: "n8" },
      { kind: "video", id: "v6" },
    ],
  },
  {
    id: "s3",
    title: "现场的力量：音乐回归舞台",
    cover: "https://readdy.ai/api/search-image?query=energetic%20concert%20crowd%20with%20warm%20red%20and%20orange%20stage%20lights%2C%20live%20music%20poster%20style%2C%20dramatic%20haze%2C%20no%20text&width=1200&height=680&seq=special-live-03&orientation=landscape",
    intro: "从巡演到音乐节，现场演出正在以惊人的速度回归。本专题带你回到那些心跳加速的舞台瞬间。",
    editorNote: "耳机里再好的音乐，也比不上站在人群里被同一段旋律击中的那一刻。",
    tags: ["音乐", "演唱会", "现场"],
    items: [
      { kind: "news", id: "n3" },
      { kind: "video", id: "v5" },
      { kind: "news", id: "n6" },
      { kind: "news", id: "n9" },
    ],
  },
  {
    id: "s4",
    title: "悬疑叙事的新边界",
    cover: "https://readdy.ai/api/search-image?query=dark%20mysterious%20room%20with%20old%20letters%20and%20warm%20lamp%20light%2C%20suspense%20poster%20style%2C%20deep%20shadows%20with%20red%20accent%2C%20no%20text&width=1200&height=680&seq=special-suspense-04&orientation=landscape",
    intro: "反转不是目的，让人物立得住才是。本专题拆解近期最被讨论的悬疑作品。",
    editorNote: "好的悬疑不是骗过观众，而是让观众心甘情愿地被故事带着走。",
    tags: ["悬疑", "叙事", "影评"],
    items: [
      { kind: "news", id: "n4" },
      { kind: "video", id: "v3" },
      { kind: "news", id: "n10" },
    ],
  },
  {
    id: "s5",
    title: "东方美学的当代表达",
    cover: "https://readdy.ai/api/search-image?query=oriental%20mythical%20scene%20with%20red%20lanterns%20clouds%20and%20ancient%20mountains%2C%20stylized%20animation%20poster%20style%2C%20warm%20red%20and%20gold%20palette%2C%20no%20text&width=1200&height=680&seq=special-oriental-05&orientation=landscape",
    intro: "当传统美学遇上现代动画与数字制作，东方故事正在被重新讲述。",
    editorNote: "真正的国风不是堆砌符号，而是把审美融入每一个镜头的呼吸里。",
    tags: ["国漫", "美学", "文化"],
    items: [
      { kind: "news", id: "n7" },
      { kind: "video", id: "v4" },
      { kind: "news", id: "n12" },
    ],
  },
  {
    id: "s6",
    title: "热搜背后的娱乐现场",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20abstract%20entertainment%20news%20collage%20with%20deep%20red%20and%20dark%20tones%2C%20bold%20editorial%20poster%20style%2C%20no%20text&width=1200&height=680&seq=special-hot-06&orientation=landscape",
    intro: "热搜每分钟都在变，但有些故事值得停下来看完。本专题持续追踪全网娱乐热点。",
    editorNote: "热点会过去，但我们仍然想把它看清楚一点。",
    tags: ["热点", "八卦", "追踪"],
    items: [
      { kind: "news", id: "n9" },
      { kind: "news", id: "n11" },
      { kind: "video", id: "v9" },
      { kind: "news", id: "n5" },
    ],
  },
];